export const DATA_CONNECTIONS = {
  FETCH_DATA_CONNECTIONS: 'DC/FETCH_DATA_CONNECTIONS',
  FETCH_FILTERS: 'DC/FETCH_FILTERS',
  UPLOAD_DATA_IN_FILE: 'UPLOAD_DATA_IN_FILE',
};
